// import { useNavigate } from "react-router-dom";
import { BatchUploadComp } from "../../../components";
// import AdminLayout from "../../../Layout/AdminLayout";

export const BatchUpload = () => {
  // const navigate = useNavigate();

  return <BatchUploadComp />;
};
